import {
  setMessageVisibility,
  getCheckoutCoownersData,
  getQuotation,
  getIsOperatorFromSelector,
} from 'app/services/businessFunctionHelpers';
import { MessagesEnum, FormsEnum } from 'app/shared/enums';
import { checkIsDataObfuscated } from 'app/services/businessFunctions/helpers/checkIsDataObfuscated';
import { handleObfuscatedFieldConsentReset } from 'app/services/businessFunctions/helpers/handleObfuscatedFieldConsentReset';

const firstCoownerObfuscation = {
  showCoownersNameObfuscatedMessage(initialRun?: boolean) {
    const { nameCheckoutForm } = getCheckoutCoownersData()[1];
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: nameCheckoutForm || '',
      initialRun,
      messageKey: MessagesEnum.CoownersNameObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'person',
        trackedPerson: 'coowner1',
        field: 'name',
      },
    });
  },
  showCoownersLastNameObfuscatedMessage(initialRun?: boolean) {
    const { lastNameCheckoutForm } = getCheckoutCoownersData()[1];
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: lastNameCheckoutForm || '',
      initialRun,
      messageKey: MessagesEnum.CoownersLastNameObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'person',
        trackedPerson: 'coowner1',
        field: 'lastName',
      },
    });
  },
  showCoownersPeselObfuscatedMessage(initialRun?: boolean) {
    const { peselCheckoutForm } = getCheckoutCoownersData()[1];
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: peselCheckoutForm || '',
      initialRun,
      messageKey: MessagesEnum.CoownersPeselObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'person',
        trackedPerson: 'coowner1',
        field: 'peselNumber',
      },
    });
  },
  showCoownersPassportObfuscatedMessage(initialRun?: boolean) {
    const { passport } = getCheckoutCoownersData()[1];

    const showObfuscatedMessage = checkIsDataObfuscated(passport, initialRun);
    setMessageVisibility({
      key: MessagesEnum.CoownersPassportObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
  showCoownersFamilyNameObfuscatedMessage(initialRun?: boolean) {
    const { familyName } = getCheckoutCoownersData()[1];

    const showObfuscatedMessage = checkIsDataObfuscated(familyName, initialRun);

    setMessageVisibility({
      key: MessagesEnum.FirstCoownerFamilyNameObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
  showCoownersLegalAddressStreetNameObfuscatedMessage(initialRun?: boolean) {
    const { legalAddress } = getCheckoutCoownersData()[1];

    const showObfuscatedMessage = checkIsDataObfuscated(
      legalAddress?.streetName,
      initialRun
    );

    setMessageVisibility({
      key: MessagesEnum.CoownersLegalAddressStreetNameObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
};

export default firstCoownerObfuscation;
